import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/**
 * Overlay shown while rediarization / minutes generation is in progress.
 * Displays a pulsing animation and status text.
 */
export default function ProcessingOverlay({ state }) {
  const { t } = useTranslation();

  const label = state === 'rediarizing'
    ? (t('mm_processing_transcript') || 'Refining transcript...')
    : (t('mm_processing_minutes') || 'Generating minutes...');

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 5,
      gap: 2.5,
      animation: 'processingFadeIn 0.4s ease',
      '@keyframes processingFadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
      },
    }}>
      {/* Animated dots */}
      <Box sx={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        {[0, 1, 2].map(i => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              animation: 'processingPulse 1.4s ease-in-out infinite',
              animationDelay: `${i * 0.2}s`,
              '@keyframes processingPulse': {
                '0%, 80%, 100%': { opacity: 0.2, transform: 'scale(0.8)' },
                '40%': { opacity: 1, transform: 'scale(1.2)' },
              },
            }}
          />
        ))}
      </Box>

      <Typography variant="body2" sx={{
        color: 'text.secondary',
        fontWeight: 500,
        letterSpacing: '0.02em',
      }}>
        {label}
      </Typography>
    </Box>
  );
}
